import { SiteConfig } from '../site-config.interface';
import { avraxGroupConfig } from './avrax-group.config';
import { avraxImpactWindowsConfig } from './avrax-impact-windows.config';
import { avraxRoofingConfig } from './avrax-roofing.config';
import { avraxKitchenBathConfig } from './avrax-kitchen-bath.config';
import { avraxPoolsConfig } from './avrax-pools.config';

export const SITE_CONFIGS: Record<string, SiteConfig> = {
  'avrax-group': avraxGroupConfig,
  'avrax-impact-windows': avraxImpactWindowsConfig,
  'avrax-roofing': avraxRoofingConfig,
  'avrax-kitchen-bath': avraxKitchenBathConfig,
  'avrax-pools': avraxPoolsConfig,
};
